import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

import VueGtag from 'vue-gtag'
import Clarity from '@microsoft/clarity'

import { getFAIcons } from './components/icons/fontawsomeAdds'
getFAIcons()

// Vuetify
import 'vuetify/styles'
import { type IconAliases, createVuetify, type ThemeDefinition } from 'vuetify'
import { aliases as defaultAliases, fa } from 'vuetify/iconsets/fa-svg'
import * as directives from 'vuetify/directives'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import Vue3Marquee from 'vue3-marquee'

// VCalendar (for Upcoming Events date picker only)
import { setupCalendar } from 'v-calendar'

const myCustomTheme: ThemeDefinition = {
  colors: {
    primary: '#0277bd',
    secondary: '#e1f5fe',
    tertiary: '#f1ebd9',
    confirm: '#2e7d32',
    cancel: '#b71c1c',
    cuGold: '#CFB87C',
    // request colors
    customerActionNeeded: '#FFD700'
  },
  variables: {
    'hover-opacity': 0.02
  }
}

import { getCustomIcons } from './assets/icons/AddCustomIcons'

const aliases: IconAliases = {
  ...defaultAliases,
  ...getCustomIcons()
}

export const vuetify = createVuetify({
  components: {
    VDateInput,
    VTimePicker
  },
  directives,
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa
    }
  },
  ssr: true,
  theme: {
    defaultTheme: 'myCustomTheme',
    themes: {
      myCustomTheme
    }
  }
})

const app = createApp(App)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
app.component('font-awesome-icon', FontAwesomeIcon)

import VueCal from 'vue-cal'
app.component('vue-cal', VueCal)

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)
app.use(pinia)

app.use(router)

app.use(vuetify)

app.use(setupCalendar, {})

app.use(Vue3Marquee)

app.use(VueGtag, {
  config: { id: __G_ANALYTICS_ID__ }
})

Clarity.init(__MS_CLARITY_ID__)

import { handleFrontendError } from './utils/errorHandling'
app.config.errorHandler = handleFrontendError

router.isReady().then(() => {
  app.mount('#app')
})
